import React from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

export const UrlHistory = () => {
    const history = useHistory();
    const currentPath = history.location.pathname;
    const pathArray = currentPath.split("/").filter(Boolean);

    const pathNames = {
        "dashboard": "Painel",
        "projects": "Projetos",
        "new": "Novo",
        "prompts": "Prompts",
        "prompt": "Prompt",
        "edit": "Editar",
        "users": "Usuários",
        "user": "Usuário",
        "apikeys": "API Keys",
    };

    if (pathArray.length <= 2) return null;

    return (
        <div
            style={{
                display: "flex",
                alignItems: "start",
                justifyContent: "start"
            }}
        >
            {pathArray.slice(1).map((segment, index) => {
                const isNextSegmentANumber = index + 2 < pathArray.length && !isNaN(Number(pathArray[index + 2]));
                const toPath = isNextSegmentANumber
                    ? `/${pathArray.slice(0, index + 2).join("/")}`
                    : `/${pathArray.slice(0, index + 2).join("/")}`;

                const finalPath = isNaN(Number(segment))
                    ? toPath
                    : `/${pathArray.slice(0, index + 1).join("/")}`;

                const displayName = pathNames[segment] || segment;

                return (
                    <React.Fragment key={index}>
                        {index > 0 && <span style={{ margin: "0 10px" }}> &gt; </span>}
                        <Link
                            to={finalPath}
                            style={{ textDecoration: "none", color: "black" }}
                        >
                            {displayName}
                        </Link>
                    </React.Fragment>
                );
            })}
        </div>
    );
};
